import styles from "./TableCell.module.css";

const TableCell = ({ value }) => {
  if (value === true) {
    return (
      <div className={styles.center}>
        <img src="/assets/subscriptions/active.svg" alt=""/>
      </div>
    );
  }

  if (value === false) {
    return (
      <div className={styles.center}>
        <img src="/assets/subscriptions/locked.svg" alt=""/>
      </div>
    );
  }

  return <div className={styles.text}>{value}</div>;
};

export default TableCell;